module.exports = __webpack_public_path__ + "static/media/icon_wechat.fa87cd5d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_wechat.svg
// module id = 1213
// module chunks = 0